import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getConsumableCalendarApi,
    getConsumableDictTreeApi,
    getConsumableByDateApi,
    getConsumableByIdApi,
    getConsumableSumDataApi,
    postConsumableCommentApi,
    putConsumableCommentApi,
    postConsumableSumDataApi,
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    listData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
    id: '',
}

/* 获取日历上的数据 */
export const getConsumableCalendarAction = createAsyncThunk(
    'ConsumableSlice/getConsumableCalendarAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getConsumableCalendarApi(params)
            return data.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据字典 */
export const getConsumableDictDataAction = createAsyncThunk(
    'ConsumableSlice/getConsumableDictDataAction',
    async (dictType, thunkAPI) => {
        const consumableSumTypeDataDict = getConsumableDictTreeApi(dictType[0])
        const unitTypeDataDict = getConsumableDictTreeApi(dictType[1])
        const useTypeDataDict = getConsumableDictTreeApi(dictType[2])
        return Promise.all([consumableSumTypeDataDict, unitTypeDataDict, useTypeDataDict])
            .then(dictData => dictData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 通过日期获取 id */
export const getConsumableByDateAction = createAsyncThunk(
    'ConsumableSlice/getConsumableByDateAction',
    async (listDataParams, thunkAPI) => {
        try {
            const commentData = await getConsumableByDateApi(listDataParams) // 通过日期查询 id
            return commentData?.data?.data?.id
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据 */
export const getConsumableDataAction = createAsyncThunk(
    'ConsumableSlice/getConsumableDataAction',
    async (id, thunkAPI) => {
        const commentData = getConsumableByIdApi(id) // 通过 id 查询
        const consumableSumData = getConsumableSumDataApi(id)
        return Promise.all([commentData, consumableSumData])
            .then(listData => listData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 保存数据 */
export const postConsumableDataAction = createAsyncThunk(
    'ConsumableSlice/postConsumableDataAction',
    async ({ id, commentParams, consumableParams, isCopyData }, { dispatch }) => {
        let vid
        try {
            if (!id || isCopyData) {
                const commentData = await postConsumableCommentApi(commentParams) // 新增
                vid = commentData.data.data.id
                await postConsumableSumDataApi(consumableParams, vid)
                dispatch(ConsumableSlice.actions.addId(vid))
                return { isTrue: true, id: vid } // 已保存状态
            } else {
                vid = id
                await putConsumableCommentApi(commentParams, id) // 修改
                await postConsumableSumDataApi(consumableParams, id)
                return { isTrue: true, id } // 已保存状态
            }
        } catch (error) {
            dispatch(ConsumableSlice.actions.addId(vid))
            dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const ConsumableSlice = createSlice({
    name: 'ConsumableSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.listData = null
            state.calendarData = null
            state.save = false
            state.id = ''
        },
        /* 当前日历主 id */
        addId: (state, action) => {
            state.id = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getConsumableCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getConsumableDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* 提交总结数据 */
        [postConsumableDataAction.fulfilled.type]: (state, action) => {
            state.save = action.payload
        },

        /* 获取回显数据 */
        [getConsumableDataAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
        },

        /* 通过日期，获取 id */
        [getConsumableByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
